import React from 'react';
import { Link } from "react-router-dom";

const BreadCrumb = (props: any) => {

  const breadcrumbs: any[] = [];

  props.links.forEach((data: any) => {
    let classNames = "breadcrumb-item";
    let link = <Link to={data.link}>{data.name}</Link>;
    if( !data.active ){
      classNames += ' active';
      link = data.name;
    }

    breadcrumbs.push(<li className={classNames}>{link}</li>)
  })

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbs}
      </ol>
    </nav>
  )

}

export default BreadCrumb
